/** @jsx isolateComponent */
import { useRef, useState } from 'react';
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Animation, Colors, Heading, Spacer, Surface, Typography, } from '@zapier/design-system';
const bodyCss = (size) => css `
  padding: ${size === 'small' ? '20px 10px' : '30px 40px'};
  display: grid;
  grid-row-gap: 10px;
`;
const headingCss = (isDimmed, size) => css `
  ${Typography[size === 'small' ? 'pageHeader9' : 'pageHeader7']}
  transition-property: color;
  transition-timing-function: ${Animation.transitionTimingFunction};
  transition-duration: ${Animation.transitionDuration};
  color: ${Colors[isDimmed ? 'neutral700' : 'neutral800']};
`;
const contentCss = () => css `
  background-color: ${Colors.neutral200};
  border-radius: 5px;
  padding: 0 15px;
  height: 50px;
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: 1fr min-content;
  align-items: center;
`;
const childrenCss = css `
  ${Typography.smallPrint1Semibold}
  color: ${Colors.neutral800};
  transition-property: opacity;
  transition-timing-function: ${Animation.transitionTimingFunction};
  transition-duration: ${Animation.transitionDuration};
  opacity: ${0.6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const editCss = css `
  ${Typography.smallPrint1}
  color: ${Colors.blueJeans};
  text-decoration: underline;
  &:hover,
  &:focus {
    color: ${Colors.night};
  }
`;
const footerCss = css `
  border-radius: 0 0 10px 10px;
  overflow: hidden;
`;
/**
 * Renders a collapsed question.
 */
const CollapsedBlock = ({ children, footer, isDimmed = false, onClickEdit, size = 'large', title, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const onMouseEnter = useRef(() => setIsHovered(true)).current;
    const onMouseLeave = useRef(() => setIsHovered(false)).current;
    const isHeadingDimmed = isDimmed && !isHovered;
    return (isolateComponent("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        isolateComponent(Surface, { backgroundColor: "neutral100", borderColor: "neutral400" },
            isolateComponent("div", { css: bodyCss(size) },
                isolateComponent(Heading, { css: headingCss(isHeadingDimmed, size) }, title),
                isolateComponent(Spacer, { height: 10 }),
                isolateComponent("div", { css: contentCss() },
                    isolateComponent("div", { css: childrenCss }, children),
                    isolateComponent("button", { css: editCss, onClick: () => onClickEdit() }, "Edit"))),
            footer && isolateComponent("div", { css: footerCss }, footer))));
};
export default CollapsedBlock;
